<div class="attachments-panel">
  <div class="panel-title">{{ label }}</div>

  @if (currentAttachment) {
    <div class="attachments-scroll">
      <div class="attachments-row">
        <div class="file-name" [title]="currentAttachment.fileNameOriginal">
          {{ currentAttachment.fileNameOriginal }}
          <span class="current-badge">Current</span>
        </div>
        <div class="actions">
          <button
            type="button"
            class="btn btn-outline-secondary btn-icon"
            title="Download file"
            (click)="downloadFile(currentAttachment)">
            <i class="fa fa-solid fa-download"></i>
          </button>
        </div>
      </div>

      @for (attachment of previousAttachments; track attachment.url) {
        <div class="attachments-row previous">
          <div class="file-name" [title]="attachment.fileNameOriginal">{{ attachment.fileNameOriginal }}</div>
          <div class="actions">
            <button
              type="button"
              class="btn btn-outline-secondary btn-icon"
              title="Download file"
              (click)="downloadFile(attachment)">
              <i class="fa fa-solid fa-download"></i>
            </button>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="empty-text">No evidence yet</div>
  }

  @if (canUpload) {
    <div class="add-file">
      <input type="file" #fileInput (change)="onFileSelected($event)" class="hidden-file-input" />
      <button type="button" class="btn btn-primary" [disabled]="isUploading" (click)="fileInput.click()">
        <i class="fa fa-solid fa-plus me-1"></i> Add file
      </button>
    </div>
  } @else if (!readonlyAttachmentsPanel) {
    <div class="empty-text">Save the risk to attach an evidence</div>
  }
</div>
